import React from "react";

function SplashScreen() {
  return (
    <div className="flex items-center justify-center h-screen bg-primary">
      <h1 className="text-white text-[50px] font-bold">Zwallet</h1>
    </div>
  );
}

export default SplashScreen;
